import type { GetProjectComments200PageAllOf } from './getProjectComments200PageAllOf';
import type { GetProjectComments200PageAllOfThree } from './getProjectComments200PageAllOfThree';

export type GetProjectComments200Page = GetProjectComments200PageAllOf & GetProjectComments200PageAllOfThree;
